import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Typography,
} from '@mui/material';

import { IActivation } from '@/interfaces/activation';
import React from 'react';
import { displayGender } from '../utils';

interface ActivationCardProps {
  onViewActivation: (activation: IActivation) => void;
  activation: IActivation;
}

const ActivationCard: React.FC<ActivationCardProps> = ({
  onViewActivation,
  activation,
}) => {
  return (
    <Card
      sx={{
        width: '300px',
        height: '310px',
      }}
    >
      <CardActionArea onClick={() => onViewActivation(activation)}>
        <CardHeader title={activation.name} />
        <CardContent>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            gap={1}
            sx={{
              overflow: 'hidden',
            }}
          >
            <Typography variant="body1" fontWeight="bold">
              Demographics
            </Typography>
            <Box display="flex" gap={1} alignItems={'center'}>
              <Typography variant="body1">
                {activation.age_min} - {activation.age_max}
              </Typography>
              /
              <Typography variant="body1">
                {displayGender(activation.gender)}
              </Typography>
            </Box>
            <Typography variant="body1" fontWeight="bold">
              Country
            </Typography>
            <Typography variant="body1">
              {activation.countries.join(', ')}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              People who match
            </Typography>
            {activation.interests ? (
              <Typography variant="body1">
                {activation.interests.length} interests
              </Typography>
            ) : (
              <Typography variant="body1">No interests</Typography>
            )}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ActivationCard;
